<template>
  <div
    class="date-time-picker-input"
    :class="{ 'date-time-picker-input--focus': isFocused, 'mb-1': range, 'valid': !valid }"
    @click="onClick"
  >
    <span v-if="displayDate">{{ displayDate }}</span>
    <span v-else style="color: #cbd5e0;">{{ displayPlaceholder }}</span>
    <div
      v-show="displayDate"
      style="position: absolute; right: 0.75em; color: #718096; cursor: pointer;"
      @click.stop="onClear"
    >
      ×
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: {
      type: [String, Object],
      required: false,
      default: null
    },
    range: {
      type: Boolean,
      required: false,
      default: false
    },
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    dateFormat: {
      type: String,
      required: false,
      default: 'YYYY年M月D日 H:mm'
    },
    end: {
      type: Boolean,
      required: false,
      default: true
    },
    isEnd: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyDate: {
      type: Boolean,
      required: false,
      default: false
    },
    valid: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    isFocused() {
      const { show } = this

      if (this.range) {
        if (this.end) {
          return show && this.isEnd
        } else {
          return show && !this.isEnd
        }
      } else {
        return show
      }
    },
    displayDate() {
      const { value } = this
      let date = null

      if (this.range) {
        if (value) {
          date = this.end ? value.end : value.start
        }
      } else {
        date = value
      }

      return date ? this.generateDateText({ date }) : null
    },
    displayPlaceholder() {
      const target = this.onlyDate ? '日' : '日時'

      if (this.range) {
        const prefix = this.end ? '終了' : '開始'
        return `${prefix}${target}`
      } else {
        return `${target}`
      }
    }
  },
  methods: {
    onClick(event) {
      this.$emit('click', event)
    },
    onClear() {
      this.$emit('clear')
    },
    generateDateText(payload) {
      const { date } = payload
      return date ? moment(date).format(this.dateFormat) : '未設定'
    }
  }
}
</script>

<style scoped>
.date-time-picker-input {
  display: flex;
  position: relative;
  align-items: center;
  padding: 0 0.75em;
  height: 2.5em;
  font-size: 0.875em;
  border-radius: 0.25em;
  border: 1px solid #cbd5e0;
  background-color: #fff;
}

.date-time-picker-input--focus {
  border-color: #63b3ed;
}

.valid {
  border-color: #b71c1c;
}
</style>
